import http from '~/common/http'
export default {
    getIndex(params) {
        return http.get('/api/order-contract-seal/index', {
            params: params
        });
    },
    getMyIndex(params) {
        return http.get('/api/order-contract-seal/my-index', {
            params: params
        });
    },
    create(data) {
        return http.post("/api/order-contract-seal/create", data);
    },

    update(data) {
        return http.put("/api/order-contract-seal/update", data);
    },

    //（单个及批量）
    delete(ids) {
        return http.delete('/api/order-contract-seal/delete', {
            data: ids
        })
    },

    contractTypes(is_search = false) {
        let types = [
            {
                value: 1,
                label: '正式合同'
            },
            {
                value: 2,
                label: '报销合同'
            },
            {
                value: 3,
                label: '政采合同'
            },
            {
                value: 4,
                label: '空白合同'
            },
            {
                value: 0,
                label: '其他'
            }
        ];
        if(is_search){
            types.splice(0, 0, {value: '', label: '不限'});
        }
        return types;
    }
}


// WEBPACK FOOTER //
// ./src/services/OrderContractSeal.js